module.exports = __webpack_public_path__ + "static/media/steampunk-gear-cog-wheels.aaf05fb1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/about/steampunk-gear-cog-wheels.svg
// module id = 382
// module chunks = 0